<script>
  export let handleFiles;
  export let multi;
  export let clear;

  let dropArea;
  let input;
  let fileValue;
  let hi=false;

  function handleFilesInput(e) {
    console.log("dropzone - handleFilesInput - ", e, e.target.files)
    preHandleFiles(e.target.files);
    fileValue="";
  }

  function preHandleFiles(pfiles) {
    let files = [...pfiles];
    handleFiles(files);
  }
 
  function dragenter(e) {
    e.preventDefault()
    e.stopPropagation()
    hi=true;
  }

  function dragover(e) {
    e.preventDefault()
    e.stopPropagation()
    hi=true;
  }
  function dragleave(e) {
    e.preventDefault()
    e.stopPropagation()
    hi=false;
  }
  function drop(e) {
    e.preventDefault()
    e.stopPropagation()
    hi=false;
    preHandleFiles(e.dataTransfer.files);
  }

$: {
  if (clear) {
    console.log("DropZone", input, input.value, input.files)
    input.value = '';
    input.files = null;
    console.log("DropZone", input, input.value, input.files)
  }
}
</script>
<style>
.drop {
  border: 2px dashed #ccc;
  border-radius: 5px;
  padding: 1rem;
}

.hi {
  border: 2px solid green;
}

.hi:hover {
  border: 2px solid #ccc;
}

.drop * {
  margin: auto;
  width: 70%;
  display: block;
}

.file {
  display: none;
}

.label:hover {
  cursor: pointer;
}
</style>

<div class="drop" class:hi
  bind:this={dropArea}
  on:dragenter={dragenter}
  on:dragover={dragover}
  on:dragleave={dragleave}
  on:drop={drop}
  >
    <input class="file" type=file multiple={multi} accept="*/*" on:change={handleFilesInput} bind:value={fileValue} bind:this={input}>
    <label class="label" for="fileElem" on:click={()=>input.click()}>Drop file{multi ? "s" : ""} here or click to upload</label>
</div>
